// Google OAuth API Service
import axios from "axios";
import { API_CONFIG } from "../config/api.config";

const API_BASE_URL = API_CONFIG.BASE_URL + "/auth";

/**
 * Login with Google OAuth
 */
export const googleLogin = async (credential) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/google-login`, {
      credential: credential,
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID
    });
    return response;
  } catch (error) {
    console.error("Google login error:", error);
    throw error;
  }
};
